import { model as i18n } from '!/i18n'
import { register } from '!/repository'
import { model as allCategory } from '$/movies/all-category'
import { formatCategoryWithVodsToUi } from '$/movies/lib'
import { genPagesLogic } from '@/effector'
import { F, T, nay } from '@/helpers'
import { type UiCategoryWithVods } from '@/interfaces'
import { api } from '@setplex/tria-api'
import { combine, createEvent, restore, sample, type Store } from 'effector'
import { not } from 'patronum'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'

export const initCategoryPage = createEvent<{
  categoryId: number
}>()

export const left = createEvent()

export const initSubCategoryPage = createEvent<{
  categoryId: number
  subCategoryId: number
}>()

/** Skeleton start*/
export const setContentLoading = createEvent<boolean>()

export const $contentLoading = restore(setContentLoading, false)
/** Skeleton end*/

export const loadMoreVodsCategoryFormatted = genPagesLogic(
  api.vods.$vodsCategoryPageInfo,
  api.vods.loadVodsFx
)

sample({
  clock: initSubCategoryPage,
  fn: (clockData) => ({ categoryId: clockData.subCategoryId }),
  target: initCategoryPage,
})

sample({
  clock: initSubCategoryPage,
  filter: not(api.vods.initVodsCategoryFx.pending),
  fn: (clockData) => ({
    categoryId: Number(clockData.subCategoryId || clockData.categoryId),
  }),
  target: api.vods.initVodsCategoryFx,
})

export const $vodsSubCategoryFormatted: Store<UiCategoryWithVods | null> =
  combine(
    api.vods.$vodsCategory,
    ssePurchasesModel.$vod,
    i18n.$t,
    (category, adjust, { t }) => formatCategoryWithVodsToUi(category, adjust, t)
  )

/********** Skeleton logics starts ***********/

sample({
  clock: initSubCategoryPage,
  fn: T,
  target: setContentLoading,
})

sample({
  clock: api.vods.initVodsCategoryFx.fail,
  fn: F,
  target: setContentLoading,
})

sample({
  clock: api.vods.loadVodsFx.pending,
  filter: nay,
  target: setContentLoading,
})

/********** Skeleton logics ends ***********/

// clear paginatable stores
api.vods.$vodsCategory.reset(initSubCategoryPage)

register($vodsSubCategoryFormatted, '$vodsSubCategory')
register(loadMoreVodsCategoryFormatted, 'loadMoreVodsCategoryFormatted')
register(
  allCategory.$infiniteVodsTitle,
  '$movies/subcategory/infiniteVodsTitle'
)
